import {
  createContext,
  useContext,
  useState
} from "react";

const AuthModalContext =
  createContext();

export const AuthModalProvider = ({ children }) => {

  const [isOpen, setIsOpen] =
    useState(false);

  const [redirectAfterAuth,
    setRedirectAfterAuth] =
    useState("/");

  const openAuthModal = (
    redirect = "/checkout"
  ) => {

    setRedirectAfterAuth(redirect);

    setIsOpen(true);

  };

  const closeAuthModal = () => {
    setIsOpen(false);
  };

  return (

    <AuthModalContext.Provider
      value={{
        isOpen,
        openAuthModal,
        closeAuthModal,
        redirectAfterAuth
      }}
    >
      {children}
    </AuthModalContext.Provider>

  );

};

export const useAuthModal = () =>
  useContext(AuthModalContext);

